import React, { useEffect, useState } from "react";
import {
    Area,
    CartesianGrid,
    ComposedChart,
    ResponsiveContainer,
    Tooltip as ChartTooltip,
    XAxis,
    YAxis,
} from "recharts";
import {Button, Card, Row, Spin} from "antd";
import Api from "../../api";
import { LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import {Link} from "react-router-dom";
import {
    DASHBOARD_AXIS_TICK,
    DASHBOARD_Y_AXIS_WIDTH,
    formatCompactNumber,
} from "./dashboard-chart-utils";


const ErrorLogChart = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [range, setRange] = useState({ startDate: moment().startOf('day').format('YYYY-MM-DD'), endDate: moment().endOf('day').format('YYYY-MM-DD') });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setLoading(true);

        Api.get('/admin/error-log').then(res => {
            processLogData(res.data.log);
            //setData(res.data);
            setLoading(false);
        });
    };

    const processLogData = (logEntries) => {
        // Filter for production.ERROR logs
        const errorLogs = logEntries.filter(entry => entry.level === 'production.ERROR');

        // Aggregate errors by hour
        const errorCounts = errorLogs.reduce((acc, log) => {
            const hour = moment(log.timestamp).format('YYYY-MM-DD HH:00:00');
            if (!acc[hour]) {
                acc[hour] = 0;
            }
            acc[hour]++;
            return acc;
        }, {});

        // Generate a list of hours in the range
        const hoursInRange = [];
        let currentHour = moment(range.startDate).startOf('day');
        const endHour = moment(range.endDate).endOf('day');

        while (currentHour <= endHour) {
            hoursInRange.push(currentHour.format('YYYY-MM-DD HH:00:00'));
            currentHour.add(1, 'hour');
        }

        // Prepare the chart data, including hours with zero errors
        const chartData = hoursInRange.map(hour => ({
            hour,
            errors: errorCounts[hour] || 0,
        }));

        setData(chartData);
    };

    return (
        <Card
            className="dashboard-chart-card"
            title={
                <Row type="flex" align="middle" justify="space-between">
                    <span>Errors</span>
                    <Link to="/error-log">
                        <Button type="link">View all</Button>
                    </Link>
                </Row>
            }
            bordered={false}
        >

            {loading && (
                <Spin indicator={<LoadingOutlined style={{fontSize: 30}} spin/>} className="spinner-loader"/>
            )}

            <div className="dashboard-chart">
                <ResponsiveContainer width="100%" height={165}>
                <ComposedChart
                    data={data}
                    margin={{
                        top: 8,
                        right: 8,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <defs>
                        <linearGradient id="colorUv10" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#ff4d4f" stopOpacity={0.3}/>
                            <stop offset="95%" stopColor="#ff4d4f" stopOpacity={0}/>
                        </linearGradient>
                    </defs>

                    <CartesianGrid strokeDasharray="3 3"/>

                    <XAxis
                        dataKey="hour"
                        tick={DASHBOARD_AXIS_TICK}
                        minTickGap={8}
                        tickFormatter={(tick) => moment(tick).format("HH:mm")}
                    />

                    <YAxis
                        domain={[0, 50]}
                        width={DASHBOARD_Y_AXIS_WIDTH}
                        tick={DASHBOARD_AXIS_TICK}
                        tickFormatter={formatCompactNumber}
                    />

                    <ChartTooltip/>

                    <Area
                        type="monotone"
                        dataKey="errors"
                        name="Errors"
                        stroke="#ff4d4f"
                        fill="url(#colorUv10)"
                    />
                </ComposedChart>
            </ResponsiveContainer>
            </div>
        </Card>
    );
};

export default ErrorLogChart;